import { Descriptions, Typography, Modal, ModalProps } from "antd"
import { useTranslation } from "react-i18next"
import { IMonitor } from "./types"
import { ReactComponent as PhoneIcon } from "assets/icons/phone.svg"
import { ReactComponent as CopyIcon } from "assets/icons/copy.svg"
import { copieToClipboard } from "utils/copy-to-clipboard"

const { Text, Link } = Typography

interface Props extends ModalProps {
  data?: IMonitor["person"]
  onClose: () => void
}

const PhoneModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation()

  return (
    <Modal
      onCancel={() => {
        props.onClose()
      }}
      footer={null}
      {...props}
    >
      <Descriptions
        style={{ marginTop: "var(--size-5)" }}
        column={1}
        items={[
          {
            key: "phone",
            label: (
              <div>
                <PhoneIcon style={{ marginRight: 10 }} />
                <Text strong>{t("labels.phone")}</Text>
              </div>
            ),
            children: data?.phone && (
              <div>
                <Link
                  href={`tel:${data.phone}`}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {data.phone}
                </Link>
                <CopyIcon
                  style={{ marginLeft: 10 }}
                  onClick={() => copieToClipboard(data.phone)}
                />
              </div>
            ),
          },
          {
            key: "mobile",
            label: (
              <div>
                <PhoneIcon style={{ marginRight: 10 }} />
                <Text strong>{t("labels.mobile")}</Text>
              </div>
            ),
            children: data?.mobile && (
              <div>
                <Link
                  href={`tel:${data.mobile}`}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {data.mobile}
                </Link>
                <CopyIcon
                  style={{ marginLeft: 10 }}
                  onClick={() => copieToClipboard(data.mobile)}
                />
              </div>
            ),
          },
          {
            key: "other",
            label: (
              <div>
                <PhoneIcon style={{ marginRight: 10 }} />
                <Text strong>{t("labels.other", { count: 1 })}</Text>
              </div>
            ),
            children: data?.phone_other && (
              <div>
                <Link
                  href={`tel:${data.phone_other}`}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {data.phone_other}
                </Link>
                <CopyIcon
                  style={{ marginLeft: 10 }}
                  onClick={() => copieToClipboard(data.phone_other)}
                />
              </div>
            ),
          },
        ]}
      />
    </Modal>
  )
}

export default PhoneModal
